export enum DeletedMessagesDisplay {
    Default = 'Default',
    ShowAsNormal = 'ShowAsNormal',
    Hide = 'Hide',
}